// dependencies imports ⇒
import React, { useState, useEffect } from "react";
// assets and scss imports ⇒
import "./abhaTokenViewTableContent.scss";
import AbhaTokenViewTableHeader from "./AbhaTokenViewTableHeader";
import AbhaTokenViewTableCell from "./AbhaTokenViewTableCell";
import DashboardFilterIcon from "../../../assets/newIcn.png";
import FilterMenuList from "../../common/Modules/FilterMenuList";
import AbhaMobileFilter from "./AbhaMobileFilter";
import AbhaTokenViewTableFooter from "./AbhaTokenViewTableFooter";
import { c2cGetApiHandler } from "../../../Util/c2cApiHandler";
import { GET_ABHA_TOKEN_LIST } from "../apiConstant";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { HEADERLIST } from "../constant";
import { ClickAwayListener } from "@mui/material";

// project file imports(UI components) ⇒

// const file imports(helper methods, etc) ⇒

const AbhaTokenViewTableContent = (props) => {
  // const declarations ⇒
  const { showMobFilter, setShowMobFilter, onhandleViewDetails } = props;
  const [selectedHeaderItem, setSelectedHeaderItem] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [abhaTokenList, setAbhaTokenList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  const [searchString, setSearchString] = useState("");
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);

  const [abhaTokenHeaderFilter, setAbhaTokenHeaderFilter] = useState([
    {
      id: 1,
      title: HEADERLIST.TOKENO,
      mobileFilterTitle: HEADERLIST.TOKENO,
      filter_icon: DashboardFilterIcon,
      show_filter: false,
      menuData: [
        {
          name: "All",
          value: "All",
          selected: true,
        },
      ],
      showApplyResetBtn: true,
      show_filter_searchbar: true,
      placeholderForSearch: "Search by Token no.",
    },
    {
      id: 2,
      title: HEADERLIST.PATIENTNAME,
      mobileFilterTitle: HEADERLIST.PATIENTNAME,
      filter_icon: DashboardFilterIcon,
      show_filter: false,
      menuData: [
        {
          name: "All",
          value: "All",
          selected: true,
        },
      ],
      showApplyResetBtn: true,
      show_filter_searchbar: true,
      placeholderForSearch: "Search by Name",
    },
    {
      id: 3,
      title: HEADERLIST.STATUS,
      mobileFilterTitle: HEADERLIST.STATUS,
      filter_icon: DashboardFilterIcon,
      show_filter: false,
      menuData: [
        {
          name: "Active",
          value: "TOKEN ACTIVE",
          selected: false,
        },
        {
          name: "Token Expired",
          value: "TOKEN EXPIRED",
          selected: false,
        },
      ],
      showApplyResetBtn: true,
      show_filter_searchbar: false,
    },
    {
      id: 4,
      title: HEADERLIST.PROFILESHAREDON,
      mobileFilterTitle: HEADERLIST.PROFILESHAREDON,
      filter_icon: DashboardFilterIcon,
      show_filter: false,
      menuData: [
        {
          name: "latest to oldest",
          value: "latest_to_oldest",
          selected: false,
        },
        {
          name: "oldest to latest",
          value: "oldest_to_latest",
          selected: false,
        },
      ],
      showApplyResetBtn: true,
      show_filter_searchbar: false,
    },
  ]);

  // let or var declarations ⇒

  // life cycle methods ⇒
  useEffect(() => {
    getAbhaTokenListApiCall();
  }, []);

  useEffect(() => {
    setShowMobFilter(showMobFilter);
    if (showMobFilter) {
      let list = [];
      abhaTokenHeaderFilter.map((menu) => menu.filter_icon && list.push(menu));
      list.forEach((li, ind) => {
        li.show_filter = false;
        if (ind === 0) {
          li.show_filter = true;
          handleMobileSelectedItem(li);
        }
      });
      setAbhaTokenHeaderFilter([...list]);
    }
  }, [showMobFilter]);

  // API Calls ⇒

  const getAbhaTokenListApiCall = (reqParams) => {
    let tokenNumberFilter = "";
    let patientNameFilter = "";
    let statusFilter = "";
    let sharedOnOrdering = "";

    abhaTokenHeaderFilter.forEach((header) => {
      switch (header.title) {
        case HEADERLIST.TOKENO:
          const selectedToken = header.menuData.find(
            (item) => item.selected && item?.value !== "All"
          );
          tokenNumberFilter = selectedToken ? selectedToken.value : "";
          break;
        case HEADERLIST.PATIENTNAME:
          const selectedPatient = header.menuData.find(
            (item) => item.selected && item?.value !== "All"
          );
          patientNameFilter = selectedPatient ? selectedPatient.value : "";
          break;
        case HEADERLIST.STATUS:
          const selectedStatus = header.menuData.find((item) => item.selected);
          statusFilter = selectedStatus ? selectedStatus.value : "";
          break;
        case HEADERLIST.PROFILESHAREDON:
          const selectedOrdering = header.menuData.find(
            (item) => item.selected
          );
          sharedOnOrdering = selectedOrdering ? selectedOrdering.value : "";
          break;
        default:
          break;
      }
    });

    let params = {
      clinic_id: clinicId,
      token_number_filter: tokenNumberFilter === "All" ? "" : tokenNumberFilter,
      patient_name_filter: patientNameFilter === "All" ? "" : patientNameFilter,
      status_filter: statusFilter,
      shared_on_ordering: sharedOnOrdering,
      page_no: pageNumber,
      records_per_page: 5,
      ...reqParams,
    };

    const abhaTokenResponse = c2cGetApiHandler(
      GET_ABHA_TOKEN_LIST(clinicId),
      params
    );
    abhaTokenResponse.then(([res, error]) => {
      if (!error && res?.data?.statusCode === 200) {
        if (res?.data?.data?.length > 0) {
          setAbhaTokenList(res?.data?.data);
          let tokenList = [
            {
              id: 0,
              name: "All",
              value: "",
              selected: tokenNumberFilter === "",
            },
          ];
          let patientList = [
            {
              id: 0,
              name: "All",
              value: "",
              selected: patientNameFilter === "",
            },
          ];
          res.data.patient_name_list.forEach((item, index) => {
            let obj = {
              id: index + 1,
              name: item,
              value: item,
              selected: item === patientNameFilter,
            };
            if (patientList?.length > 0) {
              let filterdList = patientList.filter(
                (data) => data.name === item.name
              );
              if (filterdList?.length === 0) {
                patientList.push(obj);
              }
            } else {
              patientList.push(obj);
            }
          });
          res.data.token_number_list.forEach((item, index) => {
            let obj = {
              id: index + 1,
              name: item,
              value: item,
              selected: item === tokenNumberFilter,
            };
            tokenList.push(obj);
          });

          let tempFilterHeader = [...abhaTokenHeaderFilter];
          let tokenIndex = tempFilterHeader.findIndex((data) => data?.id === 1);
          let patientIndex = tempFilterHeader.findIndex(
            (data) => data?.id === 2
          );
          tempFilterHeader[tokenIndex].menuData = tokenList;
          tempFilterHeader[patientIndex].menuData = patientList;
          setAbhaTokenHeaderFilter(tempFilterHeader);
        } else {
          setAbhaTokenList([]);
        }
        setTotalRecords(res?.data?.total_count);
      }
    });
  };

  // Helper methods ⇒

  const openMenuList = (val) => {
    abhaTokenHeaderFilter.forEach((dh) => {
      dh.show_filter = false;
    });
    let index = abhaTokenHeaderFilter.findIndex((list) => list.id === val.id);
    abhaTokenHeaderFilter[index].show_filter = true;
    setAbhaTokenHeaderFilter([...abhaTokenHeaderFilter]);
    setSelectedHeaderItem(val);
  };

  const selectMobileFilterOptions = (item) => {
    setPageNumber(1);
    let val = selectedHeaderItem;
    let index = abhaTokenHeaderFilter.findIndex((list) => list.id === val.id);
    let index1 = abhaTokenHeaderFilter[index].menuData.indexOf(item);
    abhaTokenHeaderFilter[index].menuData.map(
      (data) => (data.selected = false)
    );
    abhaTokenHeaderFilter[index].menuData[index1].selected = true;
    setAbhaTokenHeaderFilter([...abhaTokenHeaderFilter]);
  };

  // Actions ⇒

  const handleResetAllFilter = () => {
    setSearchString("")
    setPageNumber(1);
    const resetFilters = abhaTokenHeaderFilter.map((filter) => ({
      ...filter,
      menuData: filter.menuData.map((menuItem) => ({
        ...menuItem,
        selected: false,
        // selected: menuItem.name === "All",
      })),
    }));
    setAbhaTokenHeaderFilter(resetFilters);
    handleCloseMobFilter();
  };

  const handleApplyFilter = () => {
    let params = {
      page_no: 1,
    };
    getAbhaTokenListApiCall(params);
    handleCloseMobFilter();
    setSearchString("")
  };

  const handleCloseMobFilter = () => {
    setShowMobFilter(false);
  };

  const handleMobileSelectedItem = (val) => {
    setSelectedHeaderItem(val);
  };

  const handleClose = (item) => {
    setSearchString("");
    let index = abhaTokenHeaderFilter.findIndex((list) => list.id === item.id);
    abhaTokenHeaderFilter[index].show_filter = false;
    setAbhaTokenHeaderFilter([...abhaTokenHeaderFilter]);
  };

  const handleFilterSearch = (value) => {
    setSearchString(value);
  };

  const toggleItems = (item) => {
    setSearchString("");
    setPageNumber(1);
    let val = selectedHeaderItem;
    let index = abhaTokenHeaderFilter.findIndex((list) => list.id === val.id);
    abhaTokenHeaderFilter[index].show_filter = false;
    let index1 = abhaTokenHeaderFilter[index].menuData.indexOf(item);
    abhaTokenHeaderFilter[index].menuData.map(
      (data) => (data.selected = false)
    );
    abhaTokenHeaderFilter[index].menuData[index1].selected = true;
    setAbhaTokenHeaderFilter([...abhaTokenHeaderFilter]);
    let params = {
      page_no: 1,
    };
    getAbhaTokenListApiCall(params);
  };

  const onPageChange = (pageNo) => {
    setPageNumber(pageNo);
    let params = {
      page_no: pageNo,
    };
    getAbhaTokenListApiCall(params);
  };
  const getPlaceholder = () => {
    if (selectedHeaderItem) {
      const index = abhaTokenHeaderFilter.findIndex(
        (item) => item.id === selectedHeaderItem.id
      );
      if (index !== -1) {
        return abhaTokenHeaderFilter[index].placeholderForSearch;
      }
    }
    return "";
  };

  // create UI ⇒

  const displayNormalFilterList = (val) => {
    let filterdList = val.menuData.filter((menuItem) =>
      menuItem?.name
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchString.toLowerCase())
    );
    return (
      <ClickAwayListener onClickAway={() => handleClose(val)}>
        <div>
          <FilterMenuList
            menuItemList={filterdList}
            toggleItems={toggleItems}
            handleFilterSearch={handleFilterSearch}
            show_filter_searchbar={val?.show_filter_searchbar}
            placeholderForSearch={val?.placeholderForSearch}
          />
        </div>
      </ClickAwayListener>
    );
  };

  const abhaTokenViewTableContentUI = () => {
    return (
      <div className="abha-token-view-table-content-container">
        <div className="abha-token-viee-table-header-cell-wrapper">
          {window.innerWidth > 768 && (
            <AbhaTokenViewTableHeader
              abhaTokenHeaderFilter={abhaTokenHeaderFilter}
              openMenuList={openMenuList}
              displayNormalFilterList={displayNormalFilterList}
            />
          )}
          <AbhaTokenViewTableCell
            abhaTokenList={abhaTokenList}
            onhandleViewDetails={onhandleViewDetails}
          />
        </div>
        {abhaTokenList?.length > 0 && (
          <AbhaTokenViewTableFooter
            abhaTokenList={abhaTokenList}
            pageNumber={pageNumber}
            totalRecords={totalRecords}
            onPageChange={onPageChange}
          />
        )}
        {showMobFilter && (
          <AbhaMobileFilter
          searchString={searchString}
            showMobileFilter={showMobFilter}
            menuList={abhaTokenHeaderFilter}
            selectedMenu={selectedHeaderItem}
            handleClose={handleCloseMobFilter}
            openMobileMenuList={openMenuList}
            handleMobileSelectedItem={handleMobileSelectedItem}
            selectMobileFilterOptions={selectMobileFilterOptions}
            handleApplyFilter={handleApplyFilter}
            handleResetAllFilter={handleResetAllFilter}
            handleFilterSearch={handleFilterSearch}
            placeholderForSearch={getPlaceholder()}
          />
        )}
      </div>
    );
  };

  return <div>{abhaTokenViewTableContentUI()}</div>;
};

// export ⇒

export default AbhaTokenViewTableContent;
